import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import BuyPage from './pages/BuyPage';
import SellPage from './pages/SellPage';
import TransactionsPage from './pages/TransactionsPage';
import ScriptMasterPage from './pages/masters/ScriptMasterPage';
import CustomerMasterPage from './pages/masters/CustomerMasterPage';
import BrokerageMasterPage from './pages/masters/BrokerageMasterPage';

const Guard = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
};

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/" element={<Guard><Layout /></Guard>}>
        <Route index element={<Dashboard />} />
        <Route path="buy" element={<BuyPage />} />
        <Route path="sell" element={<SellPage />} />
        <Route path="transactions" element={<TransactionsPage />} />
        <Route path="masters/scripts" element={<ScriptMasterPage />} />
        <Route path="masters/customers" element={<CustomerMasterPage />} />
        <Route path="masters/brokerage" element={<BrokerageMasterPage />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
      </BrowserRouter>
    </AuthProvider>
  );
}
